// @generated by protoc-gen-es v2.12.0 with parameter "target=ts,import_extension=js"
// @generated from file morfi/v1/common.proto (package morfi.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file morfi/v1/common.proto.
 */
export const file_morfi_v1_common: GenFile = /*@__PURE__*/
  fileDesc("ChVtb3JmaS92MS9jb21tb24ucHJvdG8SCG1vcmZpLnYxIsYBCg1FdmVudE1ldGFkYXRhEgwKBHNsb3QYASABKAQSEgoKYmxvY2tfdGltZRgCIAEoAxIRCglzaWduYXR1cmUYAyABKAwSEAoIdHhfaW5kZXgYBCABKA0SGQoRaW5zdHJ1Y3Rpb25faW5kZXgYBSABKA0SJAoXaW5uZXJfaW5zdHJ1Y3Rpb25faW5kZXgYBiABKA1IAIgBARIRCgljcGlfaW5kZXgYByABKARCGgoYX2lubmVyX2luc3RydWN0aW9uX2luZGV4KlkKBFNpZGUSFAoQU0lERV9VTlNQRUNJRklFRBAAEgwKCFNJREVfQlVZEAESDQoJU0lERV9TRUxMEAISDQoJU0lERV9CQUNLEAMSDwoLU0lERV9VTkJBQ0sQBCp8CghHaWZ0S2luZBIZChVHSUZUX0tJTkRfVU5TUEVDSUZJRUQQABIhCh1HSUZUX0tJTkRfQk9ORElOR19DVVJWRV9UT0tFThABEh4KGkdJRlRfS0lORF9QUklaRV9QT09MX1NIQVJFEAISEgoOR0lGVF9LSU5EX1VTREMQAyorCg5SZXNvbHV0aW9uTW9kZRIOCgpDT05WSUNUSU9OEAASCQoFVElNRUQQAWIGcHJvdG8z");

/**
 * Per-event metadata stamped by the indexer at decode time.
 *
 * Carbon's InstructionMetadata supplies (slot, signature, absolute_path);
 * `tx_index`, `instruction_index`, `inner_instruction_index` are projected
 * from the absolute_path's first/second elements. `cpi_index` is the
 * fixed-width base-100 encoding of the full path computed by
 * encode_cpi_index() in src/utils/conversions.rs — see that function's
 * doc-comment for the encoding scheme.
 *
 * The triple `(slot, tx_index, cpi_index)` is the canonical ordering /
 * dedup key for downstream consumers: lex sort under that triple matches
 * actual on-chain execution order under post-SIMD-0268 stack depths.
 *
 * @generated from message morfi.v1.EventMetadata
 */
export type EventMetadata = Message<"morfi.v1.EventMetadata"> & {
  /**
   * cluster slot from Yellowstone update
   *
   * @generated from field: uint64 slot = 1;
   */
  slot: bigint;

  /**
   * unix seconds, cluster time from slot, may be 0 if unavailable
   *
   * @generated from field: int64 block_time = 2;
   */
  blockTime: bigint;

  /**
   * 64 bytes, transaction signature
   *
   * @generated from field: bytes signature = 3;
   */
  signature: Uint8Array;

  /**
   * transaction position within the block
   *
   * @generated from field: uint32 tx_index = 4;
   */
  txIndex: number;

  /**
   * outer instruction position in the transaction
   *
   * @generated from field: uint32 instruction_index = 5;
   */
  instructionIndex: number;

  /**
   * emit_cpi! index when nested; absent for top-level instructions
   *
   * @generated from field: optional uint32 inner_instruction_index = 6;
   */
  innerInstructionIndex?: number | undefined;

  /**
   * fixed-width encoded CPI path; sorts in execution order under (slot, tx_index, cpi_index). See encode_cpi_index() in src/utils/conversions.rs.
   *
   * @generated from field: uint64 cpi_index = 7;
   */
  cpiIndex: bigint;
};

/**
 * Describes the message morfi.v1.EventMetadata.
 * Use `create(EventMetadataSchema)` to create a new message.
 */
export const EventMetadataSchema: GenMessage<EventMetadata> = /*@__PURE__*/
  messageDesc(file_morfi_v1_common, 0);

/**
 * @generated from enum morfi.v1.Side
 */
export enum Side {
  /**
   * @generated from enum value: SIDE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: SIDE_BUY = 1;
   */
  BUY = 1,

  /**
   * @generated from enum value: SIDE_SELL = 2;
   */
  SELL = 2,

  /**
   * @generated from enum value: SIDE_BACK = 3;
   */
  BACK = 3,

  /**
   * @generated from enum value: SIDE_UNBACK = 4;
   */
  UNBACK = 4,
}

/**
 * Describes the enum morfi.v1.Side.
 */
export const SideSchema: GenEnum<Side> = /*@__PURE__*/
  enumDesc(file_morfi_v1_common, 0);

/**
 * @generated from enum morfi.v1.GiftKind
 */
export enum GiftKind {
  /**
   * @generated from enum value: GIFT_KIND_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: GIFT_KIND_BONDING_CURVE_TOKEN = 1;
   */
  BONDING_CURVE_TOKEN = 1,

  /**
   * @generated from enum value: GIFT_KIND_PRIZE_POOL_SHARE = 2;
   */
  PRIZE_POOL_SHARE = 2,

  /**
   * @generated from enum value: GIFT_KIND_USDC = 3;
   */
  USDC = 3,
}

/**
 * Describes the enum morfi.v1.GiftKind.
 */
export const GiftKindSchema: GenEnum<GiftKind> = /*@__PURE__*/
  enumDesc(file_morfi_v1_common, 1);

/**
 * Proto3 default 0 is CONVICTION. Chain/DB 0/1 map 1:1.
 *
 * @generated from enum morfi.v1.ResolutionMode
 */
export enum ResolutionMode {
  /**
   * @generated from enum value: CONVICTION = 0;
   */
  CONVICTION = 0,

  /**
   * @generated from enum value: TIMED = 1;
   */
  TIMED = 1,
}

/**
 * Describes the enum morfi.v1.ResolutionMode.
 */
export const ResolutionModeSchema: GenEnum<ResolutionMode> = /*@__PURE__*/
  enumDesc(file_morfi_v1_common, 2);

